module.exports = ".card-body {\n  padding: 10px; }\n\n.card {\n  padding: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/spk/layouts/spk-card/spk-card.component.scss
// module id = ./src/app/components/framework/spk/layouts/spk-card/spk-card.component.scss
// module chunks = main